import { useTranslation } from 'react-i18next';

export default function AchievementsSection() {

  const { t } = useTranslation();

  const achievements = [
    {
      icon: 'ri-building-line',
      number: '20+',
      label: t('about.yearsOfExp'),
      description: t('about.yearsOfExp.desc')
    },
    {
      icon: 'ri-money-dollar-circle-line',
      number: '80B',
      label: t('about.dailyTrade'),
      description: t('about.dailyTrade.desc')
    },
    {
      icon: 'ri-team-line',
      number: '1000+',      
      label: t('about.satClients'),
      description: t('about.satClients.desc')
    },
    {
      icon: 'ri-speed-line',
      number: '0.01s',      
      label: t('about.exeSpeed'),
      description: t('about.exeSpeed.desc')
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-amber-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('about.ourAch')}</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('about.ourAch.desc')}
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {achievements.map((achievement, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${achievement.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-2">{achievement.number}</h3>
              <h4 className="text-lg font-semibold text-amber-600 mb-3">{achievement.label}</h4>
              <p className="text-gray-600 text-sm leading-relaxed">{achievement.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
